/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as WorkspaceRouteImport } from './routes/_workspace'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AuthCheckEmailRouteImport } from './routes/_auth/check-email'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthTwoFactorRouteImport } from './routes/_auth/two-factor'
import { Route as WorkspaceIndexRouteImport } from './routes/_workspace/index'
import { Route as WorkspaceAlertsRouteImport } from './routes/_workspace/alerts'
import { Route as WorkspaceAuditRouteImport } from './routes/_workspace/audit'
import { Route as WorkspaceBroadcastsRouteImport } from './routes/_workspace/broadcasts'
import { Route as WorkspaceCredentialsRouteImport } from './routes/_workspace/credentials'
import { Route as WorkspaceDocumentsRouteImport } from './routes/_workspace/documents'
import { Route as WorkspaceLeaveRouteImport } from './routes/_workspace/leave'
import { Route as WorkspaceOnboardingRouteImport } from './routes/_workspace/onboarding'
import { Route as WorkspaceRequestsRouteImport } from './routes/_workspace/requests'
import { Route as WorkspaceSettingsRouteImport } from './routes/_workspace/settings'
import { Route as WorkspaceSupportRouteImport } from './routes/_workspace/support'
import { Route as AcceptInvitationIdRouteImport } from './routes/accept-invitation/$id'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as PortalAnnouncementsRouteImport } from './routes/portal/announcements'
import { Route as PortalCredentialsRouteImport } from './routes/portal/credentials'
import { Route as PortalDetailsRouteImport } from './routes/portal/details'
import { Route as PortalDocumentsRouteImport } from './routes/portal/documents'
import { Route as PortalLeaveRouteImport } from './routes/portal/leave'
import { Route as PortalOnboardingRouteImport } from './routes/portal/onboarding'
import { Route as PortalPoliciesRouteImport } from './routes/portal/policies'
import { Route as PortalRequestsRouteImport } from './routes/portal/requests'
import { Route as SignTokenRouteImport } from './routes/sign/$token'
import { Route as WorkspaceAssetsIndexRouteImport } from './routes/_workspace/assets/index'
import { Route as WorkspaceAssetsIdRouteImport } from './routes/_workspace/assets/$id'
import { Route as WorkspaceAttendanceIndexRouteImport } from './routes/_workspace/attendance/index'
import { Route as WorkspaceAttendanceIdRouteImport } from './routes/_workspace/attendance/$id'
import { Route as WorkspaceDocumentIdRouteImport } from './routes/_workspace/document/$id'
import { Route as WorkspaceEmployeesIndexRouteImport } from './routes/_workspace/employees/index'
import { Route as WorkspaceEmployeesNewRouteImport } from './routes/_workspace/employees/new'
import { Route as WorkspaceGenerateIndexRouteImport } from './routes/_workspace/generate/index'
import { Route as WorkspaceGenerateTypeRouteImport } from './routes/_workspace/generate/$type'
import { Route as WorkspaceGenerateBlankRouteImport } from './routes/_workspace/generate/blank'
import { Route as WorkspaceIncidentsIndexRouteImport } from './routes/_workspace/incidents/index'
import { Route as WorkspaceIncidentsIdRouteImport } from './routes/_workspace/incidents/$id'
import { Route as WorkspacePoliciesIndexRouteImport } from './routes/_workspace/policies/index'
import { Route as WorkspacePoliciesIdRouteImport } from './routes/_workspace/policies/$id'
import { Route as WorkspaceSettingsIndexRouteImport } from './routes/_workspace/settings/index'
import { Route as WorkspaceSettingsAccountRouteImport } from './routes/_workspace/settings/account'
import { Route as WorkspaceSettingsAttendanceRouteImport } from './routes/_workspace/settings/attendance'
import { Route as WorkspaceSettingsBillingRouteImport } from './routes/_workspace/settings/billing'
import { Route as WorkspaceSettingsCompanyRouteImport } from './routes/_workspace/settings/company'
import { Route as WorkspaceSettingsCredentialsRouteImport } from './routes/_workspace/settings/credentials'
import { Route as WorkspaceSettingsLetterheadsRouteImport } from './routes/_workspace/settings/letterheads'
import { Route as WorkspaceSettingsNamingRouteImport } from './routes/_workspace/settings/naming'
import { Route as WorkspaceSettingsTeamRouteImport } from './routes/_workspace/settings/team'
import { Route as WorkspaceSettingsUsageRouteImport } from './routes/_workspace/settings/usage'
import { Route as KioskAttendanceIdRouteImport } from './routes/kiosk/attendance.$id'
import { Route as PortalAssetsIndexRouteImport } from './routes/portal/assets/index'
import { Route as PortalAttendanceIndexRouteImport } from './routes/portal/attendance/index'
import { Route as PortalAttendanceScanRouteImport } from './routes/portal/attendance/scan'
import { Route as PortalSignTokenRouteImport } from './routes/portal/sign/$token'
import { Route as WorkspaceAssetsIssuesIdRouteImport } from './routes/_workspace/assets/issues/$id'
import { Route as WorkspaceEmployeesIdIndexRouteImport } from './routes/_workspace/employees/$id/index'
import { Route as WorkspaceEmployeesIdEditRouteImport } from './routes/_workspace/employees/$id/edit'
import { Route as WorkspaceGenerateBulkBatchIdRouteImport } from './routes/_workspace/generate/bulk/$batchId'
import { Route as WorkspaceGenerateCustomIdRouteImport } from './routes/_workspace/generate/custom/$id'
import { Route as WorkspaceGenerateLongformBuildIdRouteImport } from './routes/_workspace/generate/longform/$buildId'
import { Route as WorkspaceGenerateTemplatesIdRouteImport } from './routes/_workspace/generate/templates/$id'
import { Route as WorkspaceGenerateTemplatesNewRouteImport } from './routes/_workspace/generate/templates/new'
import { Route as PortalAssetsIssuesIdRouteImport } from './routes/portal/assets/issues/$id'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceRoute = WorkspaceRouteImport.update({
  id: '/_workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeRoute = UnsubscribeRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCheckEmailRoute = AuthCheckEmailRouteImport.update({
  id: '/check-email',
  path: '/check-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTwoFactorRoute = AuthTwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => AuthRoute,
} as any)
const WorkspaceIndexRoute = WorkspaceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceAlertsRoute = WorkspaceAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceAuditRoute = WorkspaceAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceBroadcastsRoute = WorkspaceBroadcastsRouteImport.update({
  id: '/broadcasts',
  path: '/broadcasts',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceCredentialsRoute = WorkspaceCredentialsRouteImport.update({
  id: '/credentials',
  path: '/credentials',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceDocumentsRoute = WorkspaceDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceLeaveRoute = WorkspaceLeaveRouteImport.update({
  id: '/leave',
  path: '/leave',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceOnboardingRoute = WorkspaceOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceRequestsRoute = WorkspaceRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceSettingsRoute = WorkspaceSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceSupportRoute = WorkspaceSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => WorkspaceRoute,
} as any)
const AcceptInvitationIdRoute = AcceptInvitationIdRouteImport.update({
  id: '/accept-invitation/$id',
  path: '/accept-invitation/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalAnnouncementsRoute = PortalAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => PortalRoute,
} as any)
const PortalCredentialsRoute = PortalCredentialsRouteImport.update({
  id: '/credentials',
  path: '/credentials',
  getParentRoute: () => PortalRoute,
} as any)
const PortalDetailsRoute = PortalDetailsRouteImport.update({
  id: '/details',
  path: '/details',
  getParentRoute: () => PortalRoute,
} as any)
const PortalDocumentsRoute = PortalDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => PortalRoute,
} as any)
const PortalLeaveRoute = PortalLeaveRouteImport.update({
  id: '/leave',
  path: '/leave',
  getParentRoute: () => PortalRoute,
} as any)
const PortalOnboardingRoute = PortalOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => PortalRoute,
} as any)
const PortalPoliciesRoute = PortalPoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => PortalRoute,
} as any)
const PortalRequestsRoute = PortalRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => PortalRoute,
} as any)
const SignTokenRoute = SignTokenRouteImport.update({
  id: '/sign/$token',
  path: '/sign/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceAssetsIndexRoute = WorkspaceAssetsIndexRouteImport.update({
  id: '/assets/',
  path: '/assets/',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceAssetsIdRoute = WorkspaceAssetsIdRouteImport.update({
  id: '/assets/$id',
  path: '/assets/$id',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceAttendanceIndexRoute =
  WorkspaceAttendanceIndexRouteImport.update({
    id: '/attendance/',
    path: '/attendance/',
    getParentRoute: () => WorkspaceRoute,
  } as any)
const WorkspaceAttendanceIdRoute = WorkspaceAttendanceIdRouteImport.update({
  id: '/attendance/$id',
  path: '/attendance/$id',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceDocumentIdRoute = WorkspaceDocumentIdRouteImport.update({
  id: '/document/$id',
  path: '/document/$id',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceEmployeesIndexRoute = WorkspaceEmployeesIndexRouteImport.update({
  id: '/employees/',
  path: '/employees/',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceEmployeesNewRoute = WorkspaceEmployeesNewRouteImport.update({
  id: '/employees/new',
  path: '/employees/new',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceGenerateIndexRoute = WorkspaceGenerateIndexRouteImport.update({
  id: '/generate/',
  path: '/generate/',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceGenerateTypeRoute = WorkspaceGenerateTypeRouteImport.update({
  id: '/generate/$type',
  path: '/generate/$type',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceGenerateBlankRoute = WorkspaceGenerateBlankRouteImport.update({
  id: '/generate/blank',
  path: '/generate/blank',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceIncidentsIndexRoute = WorkspaceIncidentsIndexRouteImport.update({
  id: '/incidents/',
  path: '/incidents/',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceIncidentsIdRoute = WorkspaceIncidentsIdRouteImport.update({
  id: '/incidents/$id',
  path: '/incidents/$id',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspacePoliciesIndexRoute = WorkspacePoliciesIndexRouteImport.update({
  id: '/policies/',
  path: '/policies/',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspacePoliciesIdRoute = WorkspacePoliciesIdRouteImport.update({
  id: '/policies/$id',
  path: '/policies/$id',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceSettingsIndexRoute = WorkspaceSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkspaceSettingsRoute,
} as any)
const WorkspaceSettingsAccountRoute =
  WorkspaceSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)
const WorkspaceSettingsAttendanceRoute =
  WorkspaceSettingsAttendanceRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)
const WorkspaceSettingsBillingRoute =
  WorkspaceSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)
const WorkspaceSettingsCompanyRoute =
  WorkspaceSettingsCompanyRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)
const WorkspaceSettingsCredentialsRoute =
  WorkspaceSettingsCredentialsRouteImport.update({
    id: '/credentials',
    path: '/credentials',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)
const WorkspaceSettingsLetterheadsRoute =
  WorkspaceSettingsLetterheadsRouteImport.update({
    id: '/letterheads',
    path: '/letterheads',
    getParentRoute: () => WorkspaceSettingsRoute,
  } as any)
const WorkspaceSettingsNamingRoute = WorkspaceSettingsNamingRouteImport.update({
  id: '/naming',
  path: '/naming',
  getParentRoute: () => WorkspaceSettingsRoute,
} as any)
const WorkspaceSettingsTeamRoute = WorkspaceSettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => WorkspaceSettingsRoute,
} as any)
const WorkspaceSettingsUsageRoute = WorkspaceSettingsUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => WorkspaceSettingsRoute,
} as any)
const KioskAttendanceIdRoute = KioskAttendanceIdRouteImport.update({
  id: '/kiosk/attendance/$id',
  path: '/kiosk/attendance/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalAssetsIndexRoute = PortalAssetsIndexRouteImport.update({
  id: '/assets/',
  path: '/assets/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalAttendanceIndexRoute = PortalAttendanceIndexRouteImport.update({
  id: '/attendance/',
  path: '/attendance/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalAttendanceScanRoute = PortalAttendanceScanRouteImport.update({
  id: '/attendance/scan',
  path: '/attendance/scan',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSignTokenRoute = PortalSignTokenRouteImport.update({
  id: '/sign/$token',
  path: '/sign/$token',
  getParentRoute: () => PortalRoute,
} as any)
const WorkspaceAssetsIssuesIdRoute = WorkspaceAssetsIssuesIdRouteImport.update({
  id: '/assets/issues/$id',
  path: '/assets/issues/$id',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceEmployeesIdIndexRoute =
  WorkspaceEmployeesIdIndexRouteImport.update({
    id: '/employees/$id/',
    path: '/employees/$id/',
    getParentRoute: () => WorkspaceRoute,
  } as any)
const WorkspaceEmployeesIdEditRoute =
  WorkspaceEmployeesIdEditRouteImport.update({
    id: '/employees/$id/edit',
    path: '/employees/$id/edit',
    getParentRoute: () => WorkspaceRoute,
  } as any)
const WorkspaceGenerateBulkBatchIdRoute =
  WorkspaceGenerateBulkBatchIdRouteImport.update({
    id: '/generate/bulk/$batchId',
    path: '/generate/bulk/$batchId',
    getParentRoute: () => WorkspaceRoute,
  } as any)
const WorkspaceGenerateCustomIdRoute =
  WorkspaceGenerateCustomIdRouteImport.update({
    id: '/generate/custom/$id',
    path: '/generate/custom/$id',
    getParentRoute: () => WorkspaceRoute,
  } as any)
const WorkspaceGenerateLongformBuildIdRoute =
  WorkspaceGenerateLongformBuildIdRouteImport.update({
    id: '/generate/longform/$buildId',
    path: '/generate/longform/$buildId',
    getParentRoute: () => WorkspaceRoute,
  } as any)
const WorkspaceGenerateTemplatesIdRoute =
  WorkspaceGenerateTemplatesIdRouteImport.update({
    id: '/generate/templates/$id',
    path: '/generate/templates/$id',
    getParentRoute: () => WorkspaceRoute,
  } as any)
const WorkspaceGenerateTemplatesNewRoute =
  WorkspaceGenerateTemplatesNewRouteImport.update({
    id: '/generate/templates/new',
    path: '/generate/templates/new',
    getParentRoute: () => WorkspaceRoute,
  } as any)
const PortalAssetsIssuesIdRoute = PortalAssetsIssuesIdRouteImport.update({
  id: '/assets/issues/$id',
  path: '/assets/issues/$id',
  getParentRoute: () => PortalRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof WorkspaceIndexRoute
  '/portal': typeof PortalRouteWithChildren
  '/unsubscribe': typeof UnsubscribeRoute
  '/verify-email': typeof VerifyEmailRoute
  '/check-email': typeof AuthCheckEmailRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/alerts': typeof WorkspaceAlertsRoute
  '/audit': typeof WorkspaceAuditRoute
  '/broadcasts': typeof WorkspaceBroadcastsRoute
  '/credentials': typeof WorkspaceCredentialsRoute
  '/documents': typeof WorkspaceDocumentsRoute
  '/leave': typeof WorkspaceLeaveRoute
  '/onboarding': typeof WorkspaceOnboardingRoute
  '/requests': typeof WorkspaceRequestsRoute
  '/settings': typeof WorkspaceSettingsRouteWithChildren
  '/support': typeof WorkspaceSupportRoute
  '/accept-invitation/$id': typeof AcceptInvitationIdRoute
  '/portal/announcements': typeof PortalAnnouncementsRoute
  '/portal/credentials': typeof PortalCredentialsRoute
  '/portal/details': typeof PortalDetailsRoute
  '/portal/documents': typeof PortalDocumentsRoute
  '/portal/leave': typeof PortalLeaveRoute
  '/portal/onboarding': typeof PortalOnboardingRoute
  '/portal/policies': typeof PortalPoliciesRoute
  '/portal/requests': typeof PortalRequestsRoute
  '/sign/$token': typeof SignTokenRoute
  '/portal/': typeof PortalIndexRoute
  '/assets/$id': typeof WorkspaceAssetsIdRoute
  '/attendance/$id': typeof WorkspaceAttendanceIdRoute
  '/document/$id': typeof WorkspaceDocumentIdRoute
  '/employees/new': typeof WorkspaceEmployeesNewRoute
  '/generate/$type': typeof WorkspaceGenerateTypeRoute
  '/generate/blank': typeof WorkspaceGenerateBlankRoute
  '/incidents/$id': typeof WorkspaceIncidentsIdRoute
  '/policies/$id': typeof WorkspacePoliciesIdRoute
  '/settings/account': typeof WorkspaceSettingsAccountRoute
  '/settings/attendance': typeof WorkspaceSettingsAttendanceRoute
  '/settings/billing': typeof WorkspaceSettingsBillingRoute
  '/settings/company': typeof WorkspaceSettingsCompanyRoute
  '/settings/credentials': typeof WorkspaceSettingsCredentialsRoute
  '/settings/letterheads': typeof WorkspaceSettingsLetterheadsRoute
  '/settings/naming': typeof WorkspaceSettingsNamingRoute
  '/settings/team': typeof WorkspaceSettingsTeamRoute
  '/settings/usage': typeof WorkspaceSettingsUsageRoute
  '/kiosk/attendance/$id': typeof KioskAttendanceIdRoute
  '/portal/attendance/scan': typeof PortalAttendanceScanRoute
  '/portal/sign/$token': typeof PortalSignTokenRoute
  '/assets/': typeof WorkspaceAssetsIndexRoute
  '/attendance/': typeof WorkspaceAttendanceIndexRoute
  '/employees/': typeof WorkspaceEmployeesIndexRoute
  '/generate/': typeof WorkspaceGenerateIndexRoute
  '/incidents/': typeof WorkspaceIncidentsIndexRoute
  '/policies/': typeof WorkspacePoliciesIndexRoute
  '/settings/': typeof WorkspaceSettingsIndexRoute
  '/portal/assets/': typeof PortalAssetsIndexRoute
  '/portal/attendance/': typeof PortalAttendanceIndexRoute
  '/assets/issues/$id': typeof WorkspaceAssetsIssuesIdRoute
  '/employees/$id/edit': typeof WorkspaceEmployeesIdEditRoute
  '/generate/bulk/$batchId': typeof WorkspaceGenerateBulkBatchIdRoute
  '/generate/custom/$id': typeof WorkspaceGenerateCustomIdRoute
  '/generate/longform/$buildId': typeof WorkspaceGenerateLongformBuildIdRoute
  '/generate/templates/$id': typeof WorkspaceGenerateTemplatesIdRoute
  '/generate/templates/new': typeof WorkspaceGenerateTemplatesNewRoute
  '/portal/assets/issues/$id': typeof PortalAssetsIssuesIdRoute
  '/employees/$id/': typeof WorkspaceEmployeesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof WorkspaceIndexRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/verify-email': typeof VerifyEmailRoute
  '/check-email': typeof AuthCheckEmailRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/alerts': typeof WorkspaceAlertsRoute
  '/audit': typeof WorkspaceAuditRoute
  '/broadcasts': typeof WorkspaceBroadcastsRoute
  '/credentials': typeof WorkspaceCredentialsRoute
  '/documents': typeof WorkspaceDocumentsRoute
  '/leave': typeof WorkspaceLeaveRoute
  '/onboarding': typeof WorkspaceOnboardingRoute
  '/requests': typeof WorkspaceRequestsRoute
  '/support': typeof WorkspaceSupportRoute
  '/accept-invitation/$id': typeof AcceptInvitationIdRoute
  '/portal/announcements': typeof PortalAnnouncementsRoute
  '/portal/credentials': typeof PortalCredentialsRoute
  '/portal/details': typeof PortalDetailsRoute
  '/portal/documents': typeof PortalDocumentsRoute
  '/portal/leave': typeof PortalLeaveRoute
  '/portal/onboarding': typeof PortalOnboardingRoute
  '/portal/policies': typeof PortalPoliciesRoute
  '/portal/requests': typeof PortalRequestsRoute
  '/sign/$token': typeof SignTokenRoute
  '/portal': typeof PortalIndexRoute
  '/assets/$id': typeof WorkspaceAssetsIdRoute
  '/attendance/$id': typeof WorkspaceAttendanceIdRoute
  '/document/$id': typeof WorkspaceDocumentIdRoute
  '/employees/new': typeof WorkspaceEmployeesNewRoute
  '/generate/$type': typeof WorkspaceGenerateTypeRoute
  '/generate/blank': typeof WorkspaceGenerateBlankRoute
  '/incidents/$id': typeof WorkspaceIncidentsIdRoute
  '/policies/$id': typeof WorkspacePoliciesIdRoute
  '/settings/account': typeof WorkspaceSettingsAccountRoute
  '/settings/attendance': typeof WorkspaceSettingsAttendanceRoute
  '/settings/billing': typeof WorkspaceSettingsBillingRoute
  '/settings/company': typeof WorkspaceSettingsCompanyRoute
  '/settings/credentials': typeof WorkspaceSettingsCredentialsRoute
  '/settings/letterheads': typeof WorkspaceSettingsLetterheadsRoute
  '/settings/naming': typeof WorkspaceSettingsNamingRoute
  '/settings/team': typeof WorkspaceSettingsTeamRoute
  '/settings/usage': typeof WorkspaceSettingsUsageRoute
  '/kiosk/attendance/$id': typeof KioskAttendanceIdRoute
  '/portal/attendance/scan': typeof PortalAttendanceScanRoute
  '/portal/sign/$token': typeof PortalSignTokenRoute
  '/assets': typeof WorkspaceAssetsIndexRoute
  '/attendance': typeof WorkspaceAttendanceIndexRoute
  '/employees': typeof WorkspaceEmployeesIndexRoute
  '/generate': typeof WorkspaceGenerateIndexRoute
  '/incidents': typeof WorkspaceIncidentsIndexRoute
  '/policies': typeof WorkspacePoliciesIndexRoute
  '/settings': typeof WorkspaceSettingsIndexRoute
  '/portal/assets': typeof PortalAssetsIndexRoute
  '/portal/attendance': typeof PortalAttendanceIndexRoute
  '/assets/issues/$id': typeof WorkspaceAssetsIssuesIdRoute
  '/employees/$id/edit': typeof WorkspaceEmployeesIdEditRoute
  '/generate/bulk/$batchId': typeof WorkspaceGenerateBulkBatchIdRoute
  '/generate/custom/$id': typeof WorkspaceGenerateCustomIdRoute
  '/generate/longform/$buildId': typeof WorkspaceGenerateLongformBuildIdRoute
  '/generate/templates/$id': typeof WorkspaceGenerateTemplatesIdRoute
  '/generate/templates/new': typeof WorkspaceGenerateTemplatesNewRoute
  '/portal/assets/issues/$id': typeof PortalAssetsIssuesIdRoute
  '/employees/$id': typeof WorkspaceEmployeesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_workspace': typeof WorkspaceRouteWithChildren
  '/portal': typeof PortalRouteWithChildren
  '/unsubscribe': typeof UnsubscribeRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_auth/check-email': typeof AuthCheckEmailRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/_auth/two-factor': typeof AuthTwoFactorRoute
  '/_workspace/alerts': typeof WorkspaceAlertsRoute
  '/_workspace/audit': typeof WorkspaceAuditRoute
  '/_workspace/broadcasts': typeof WorkspaceBroadcastsRoute
  '/_workspace/credentials': typeof WorkspaceCredentialsRoute
  '/_workspace/documents': typeof WorkspaceDocumentsRoute
  '/_workspace/leave': typeof WorkspaceLeaveRoute
  '/_workspace/onboarding': typeof WorkspaceOnboardingRoute
  '/_workspace/requests': typeof WorkspaceRequestsRoute
  '/_workspace/settings': typeof WorkspaceSettingsRouteWithChildren
  '/_workspace/support': typeof WorkspaceSupportRoute
  '/accept-invitation/$id': typeof AcceptInvitationIdRoute
  '/portal/announcements': typeof PortalAnnouncementsRoute
  '/portal/credentials': typeof PortalCredentialsRoute
  '/portal/details': typeof PortalDetailsRoute
  '/portal/documents': typeof PortalDocumentsRoute
  '/portal/leave': typeof PortalLeaveRoute
  '/portal/onboarding': typeof PortalOnboardingRoute
  '/portal/policies': typeof PortalPoliciesRoute
  '/portal/requests': typeof PortalRequestsRoute
  '/sign/$token': typeof SignTokenRoute
  '/_workspace/': typeof WorkspaceIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/_workspace/assets/$id': typeof WorkspaceAssetsIdRoute
  '/_workspace/attendance/$id': typeof WorkspaceAttendanceIdRoute
  '/_workspace/document/$id': typeof WorkspaceDocumentIdRoute
  '/_workspace/employees/new': typeof WorkspaceEmployeesNewRoute
  '/_workspace/generate/$type': typeof WorkspaceGenerateTypeRoute
  '/_workspace/generate/blank': typeof WorkspaceGenerateBlankRoute
  '/_workspace/incidents/$id': typeof WorkspaceIncidentsIdRoute
  '/_workspace/policies/$id': typeof WorkspacePoliciesIdRoute
  '/_workspace/settings/account': typeof WorkspaceSettingsAccountRoute
  '/_workspace/settings/attendance': typeof WorkspaceSettingsAttendanceRoute
  '/_workspace/settings/billing': typeof WorkspaceSettingsBillingRoute
  '/_workspace/settings/company': typeof WorkspaceSettingsCompanyRoute
  '/_workspace/settings/credentials': typeof WorkspaceSettingsCredentialsRoute
  '/_workspace/settings/letterheads': typeof WorkspaceSettingsLetterheadsRoute
  '/_workspace/settings/naming': typeof WorkspaceSettingsNamingRoute
  '/_workspace/settings/team': typeof WorkspaceSettingsTeamRoute
  '/_workspace/settings/usage': typeof WorkspaceSettingsUsageRoute
  '/kiosk/attendance/$id': typeof KioskAttendanceIdRoute
  '/portal/attendance/scan': typeof PortalAttendanceScanRoute
  '/portal/sign/$token': typeof PortalSignTokenRoute
  '/_workspace/assets/': typeof WorkspaceAssetsIndexRoute
  '/_workspace/attendance/': typeof WorkspaceAttendanceIndexRoute
  '/_workspace/employees/': typeof WorkspaceEmployeesIndexRoute
  '/_workspace/generate/': typeof WorkspaceGenerateIndexRoute
  '/_workspace/incidents/': typeof WorkspaceIncidentsIndexRoute
  '/_workspace/policies/': typeof WorkspacePoliciesIndexRoute
  '/_workspace/settings/': typeof WorkspaceSettingsIndexRoute
  '/portal/assets/': typeof PortalAssetsIndexRoute
  '/portal/attendance/': typeof PortalAttendanceIndexRoute
  '/_workspace/assets/issues/$id': typeof WorkspaceAssetsIssuesIdRoute
  '/_workspace/employees/$id/edit': typeof WorkspaceEmployeesIdEditRoute
  '/_workspace/generate/bulk/$batchId': typeof WorkspaceGenerateBulkBatchIdRoute
  '/_workspace/generate/custom/$id': typeof WorkspaceGenerateCustomIdRoute
  '/_workspace/generate/longform/$buildId': typeof WorkspaceGenerateLongformBuildIdRoute
  '/_workspace/generate/templates/$id': typeof WorkspaceGenerateTemplatesIdRoute
  '/_workspace/generate/templates/new': typeof WorkspaceGenerateTemplatesNewRoute
  '/portal/assets/issues/$id': typeof PortalAssetsIssuesIdRoute
  '/_workspace/employees/$id/': typeof WorkspaceEmployeesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/portal'
    | '/unsubscribe'
    | '/verify-email'
    | '/check-email'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/two-factor'
    | '/alerts'
    | '/audit'
    | '/broadcasts'
    | '/credentials'
    | '/documents'
    | '/leave'
    | '/onboarding'
    | '/requests'
    | '/settings'
    | '/support'
    | '/accept-invitation/$id'
    | '/portal/announcements'
    | '/portal/credentials'
    | '/portal/details'
    | '/portal/documents'
    | '/portal/leave'
    | '/portal/onboarding'
    | '/portal/policies'
    | '/portal/requests'
    | '/sign/$token'
    | '/portal/'
    | '/assets/$id'
    | '/attendance/$id'
    | '/document/$id'
    | '/employees/new'
    | '/generate/$type'
    | '/generate/blank'
    | '/incidents/$id'
    | '/policies/$id'
    | '/settings/account'
    | '/settings/attendance'
    | '/settings/billing'
    | '/settings/company'
    | '/settings/credentials'
    | '/settings/letterheads'
    | '/settings/naming'
    | '/settings/team'
    | '/settings/usage'
    | '/kiosk/attendance/$id'
    | '/portal/attendance/scan'
    | '/portal/sign/$token'
    | '/assets/'
    | '/attendance/'
    | '/employees/'
    | '/generate/'
    | '/incidents/'
    | '/policies/'
    | '/settings/'
    | '/portal/assets/'
    | '/portal/attendance/'
    | '/assets/issues/$id'
    | '/employees/$id/edit'
    | '/generate/bulk/$batchId'
    | '/generate/custom/$id'
    | '/generate/longform/$buildId'
    | '/generate/templates/$id'
    | '/generate/templates/new'
    | '/portal/assets/issues/$id'
    | '/employees/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/unsubscribe'
    | '/verify-email'
    | '/check-email'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/two-factor'
    | '/alerts'
    | '/audit'
    | '/broadcasts'
    | '/credentials'
    | '/documents'
    | '/leave'
    | '/onboarding'
    | '/requests'
    | '/support'
    | '/accept-invitation/$id'
    | '/portal/announcements'
    | '/portal/credentials'
    | '/portal/details'
    | '/portal/documents'
    | '/portal/leave'
    | '/portal/onboarding'
    | '/portal/policies'
    | '/portal/requests'
    | '/sign/$token'
    | '/portal'
    | '/assets/$id'
    | '/attendance/$id'
    | '/document/$id'
    | '/employees/new'
    | '/generate/$type'
    | '/generate/blank'
    | '/incidents/$id'
    | '/policies/$id'
    | '/settings/account'
    | '/settings/attendance'
    | '/settings/billing'
    | '/settings/company'
    | '/settings/credentials'
    | '/settings/letterheads'
    | '/settings/naming'
    | '/settings/team'
    | '/settings/usage'
    | '/kiosk/attendance/$id'
    | '/portal/attendance/scan'
    | '/portal/sign/$token'
    | '/assets'
    | '/attendance'
    | '/employees'
    | '/generate'
    | '/incidents'
    | '/policies'
    | '/settings'
    | '/portal/assets'
    | '/portal/attendance'
    | '/assets/issues/$id'
    | '/employees/$id/edit'
    | '/generate/bulk/$batchId'
    | '/generate/custom/$id'
    | '/generate/longform/$buildId'
    | '/generate/templates/$id'
    | '/generate/templates/new'
    | '/portal/assets/issues/$id'
    | '/employees/$id'
  id:
    | '__root__'
    | '/_auth'
    | '/_workspace'
    | '/portal'
    | '/unsubscribe'
    | '/verify-email'
    | '/_auth/check-email'
    | '/_auth/forgot-password'
    | '/_auth/reset-password'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/_auth/two-factor'
    | '/_workspace/alerts'
    | '/_workspace/audit'
    | '/_workspace/broadcasts'
    | '/_workspace/credentials'
    | '/_workspace/documents'
    | '/_workspace/leave'
    | '/_workspace/onboarding'
    | '/_workspace/requests'
    | '/_workspace/settings'
    | '/_workspace/support'
    | '/accept-invitation/$id'
    | '/portal/announcements'
    | '/portal/credentials'
    | '/portal/details'
    | '/portal/documents'
    | '/portal/leave'
    | '/portal/onboarding'
    | '/portal/policies'
    | '/portal/requests'
    | '/sign/$token'
    | '/_workspace/'
    | '/portal/'
    | '/_workspace/assets/$id'
    | '/_workspace/attendance/$id'
    | '/_workspace/document/$id'
    | '/_workspace/employees/new'
    | '/_workspace/generate/$type'
    | '/_workspace/generate/blank'
    | '/_workspace/incidents/$id'
    | '/_workspace/policies/$id'
    | '/_workspace/settings/account'
    | '/_workspace/settings/attendance'
    | '/_workspace/settings/billing'
    | '/_workspace/settings/company'
    | '/_workspace/settings/credentials'
    | '/_workspace/settings/letterheads'
    | '/_workspace/settings/naming'
    | '/_workspace/settings/team'
    | '/_workspace/settings/usage'
    | '/kiosk/attendance/$id'
    | '/portal/attendance/scan'
    | '/portal/sign/$token'
    | '/_workspace/assets/'
    | '/_workspace/attendance/'
    | '/_workspace/employees/'
    | '/_workspace/generate/'
    | '/_workspace/incidents/'
    | '/_workspace/policies/'
    | '/_workspace/settings/'
    | '/portal/assets/'
    | '/portal/attendance/'
    | '/_workspace/assets/issues/$id'
    | '/_workspace/employees/$id/edit'
    | '/_workspace/generate/bulk/$batchId'
    | '/_workspace/generate/custom/$id'
    | '/_workspace/generate/longform/$buildId'
    | '/_workspace/generate/templates/$id'
    | '/_workspace/generate/templates/new'
    | '/portal/assets/issues/$id'
    | '/_workspace/employees/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  WorkspaceRoute: typeof WorkspaceRouteWithChildren
  PortalRoute: typeof PortalRouteWithChildren
  UnsubscribeRoute: typeof UnsubscribeRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  AcceptInvitationIdRoute: typeof AcceptInvitationIdRoute
  SignTokenRoute: typeof SignTokenRoute
  KioskAttendanceIdRoute: typeof KioskAttendanceIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_workspace': {
      id: '/_workspace'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof WorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe': {
      id: '/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/check-email': {
      id: '/_auth/check-email'
      path: '/check-email'
      fullPath: '/check-email'
      preLoaderRoute: typeof AuthCheckEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/two-factor': {
      id: '/_auth/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof AuthTwoFactorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_workspace/': {
      id: '/_workspace/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof WorkspaceIndexRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/alerts': {
      id: '/_workspace/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof WorkspaceAlertsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/audit': {
      id: '/_workspace/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof WorkspaceAuditRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/broadcasts': {
      id: '/_workspace/broadcasts'
      path: '/broadcasts'
      fullPath: '/broadcasts'
      preLoaderRoute: typeof WorkspaceBroadcastsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/credentials': {
      id: '/_workspace/credentials'
      path: '/credentials'
      fullPath: '/credentials'
      preLoaderRoute: typeof WorkspaceCredentialsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/documents': {
      id: '/_workspace/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof WorkspaceDocumentsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/leave': {
      id: '/_workspace/leave'
      path: '/leave'
      fullPath: '/leave'
      preLoaderRoute: typeof WorkspaceLeaveRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/onboarding': {
      id: '/_workspace/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof WorkspaceOnboardingRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/requests': {
      id: '/_workspace/requests'
      path: '/requests'
      fullPath: '/requests'
      preLoaderRoute: typeof WorkspaceRequestsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/settings': {
      id: '/_workspace/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof WorkspaceSettingsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/support': {
      id: '/_workspace/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof WorkspaceSupportRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/accept-invitation/$id': {
      id: '/accept-invitation/$id'
      path: '/accept-invitation/$id'
      fullPath: '/accept-invitation/$id'
      preLoaderRoute: typeof AcceptInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/announcements': {
      id: '/portal/announcements'
      path: '/announcements'
      fullPath: '/portal/announcements'
      preLoaderRoute: typeof PortalAnnouncementsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/credentials': {
      id: '/portal/credentials'
      path: '/credentials'
      fullPath: '/portal/credentials'
      preLoaderRoute: typeof PortalCredentialsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/details': {
      id: '/portal/details'
      path: '/details'
      fullPath: '/portal/details'
      preLoaderRoute: typeof PortalDetailsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/documents': {
      id: '/portal/documents'
      path: '/documents'
      fullPath: '/portal/documents'
      preLoaderRoute: typeof PortalDocumentsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/leave': {
      id: '/portal/leave'
      path: '/leave'
      fullPath: '/portal/leave'
      preLoaderRoute: typeof PortalLeaveRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/onboarding': {
      id: '/portal/onboarding'
      path: '/onboarding'
      fullPath: '/portal/onboarding'
      preLoaderRoute: typeof PortalOnboardingRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/policies': {
      id: '/portal/policies'
      path: '/policies'
      fullPath: '/portal/policies'
      preLoaderRoute: typeof PortalPoliciesRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/requests': {
      id: '/portal/requests'
      path: '/requests'
      fullPath: '/portal/requests'
      preLoaderRoute: typeof PortalRequestsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/sign/$token': {
      id: '/sign/$token'
      path: '/sign/$token'
      fullPath: '/sign/$token'
      preLoaderRoute: typeof SignTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_workspace/assets/': {
      id: '/_workspace/assets/'
      path: '/assets'
      fullPath: '/assets/'
      preLoaderRoute: typeof WorkspaceAssetsIndexRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/assets/$id': {
      id: '/_workspace/assets/$id'
      path: '/assets/$id'
      fullPath: '/assets/$id'
      preLoaderRoute: typeof WorkspaceAssetsIdRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/attendance/': {
      id: '/_workspace/attendance/'
      path: '/attendance'
      fullPath: '/attendance/'
      preLoaderRoute: typeof WorkspaceAttendanceIndexRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/attendance/$id': {
      id: '/_workspace/attendance/$id'
      path: '/attendance/$id'
      fullPath: '/attendance/$id'
      preLoaderRoute: typeof WorkspaceAttendanceIdRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/document/$id': {
      id: '/_workspace/document/$id'
      path: '/document/$id'
      fullPath: '/document/$id'
      preLoaderRoute: typeof WorkspaceDocumentIdRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/employees/': {
      id: '/_workspace/employees/'
      path: '/employees'
      fullPath: '/employees/'
      preLoaderRoute: typeof WorkspaceEmployeesIndexRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/employees/new': {
      id: '/_workspace/employees/new'
      path: '/employees/new'
      fullPath: '/employees/new'
      preLoaderRoute: typeof WorkspaceEmployeesNewRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/generate/': {
      id: '/_workspace/generate/'
      path: '/generate'
      fullPath: '/generate/'
      preLoaderRoute: typeof WorkspaceGenerateIndexRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/generate/$type': {
      id: '/_workspace/generate/$type'
      path: '/generate/$type'
      fullPath: '/generate/$type'
      preLoaderRoute: typeof WorkspaceGenerateTypeRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/generate/blank': {
      id: '/_workspace/generate/blank'
      path: '/generate/blank'
      fullPath: '/generate/blank'
      preLoaderRoute: typeof WorkspaceGenerateBlankRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/incidents/': {
      id: '/_workspace/incidents/'
      path: '/incidents'
      fullPath: '/incidents/'
      preLoaderRoute: typeof WorkspaceIncidentsIndexRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/incidents/$id': {
      id: '/_workspace/incidents/$id'
      path: '/incidents/$id'
      fullPath: '/incidents/$id'
      preLoaderRoute: typeof WorkspaceIncidentsIdRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/policies/': {
      id: '/_workspace/policies/'
      path: '/policies'
      fullPath: '/policies/'
      preLoaderRoute: typeof WorkspacePoliciesIndexRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/policies/$id': {
      id: '/_workspace/policies/$id'
      path: '/policies/$id'
      fullPath: '/policies/$id'
      preLoaderRoute: typeof WorkspacePoliciesIdRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/settings/': {
      id: '/_workspace/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof WorkspaceSettingsIndexRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/account': {
      id: '/_workspace/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof WorkspaceSettingsAccountRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/attendance': {
      id: '/_workspace/settings/attendance'
      path: '/attendance'
      fullPath: '/settings/attendance'
      preLoaderRoute: typeof WorkspaceSettingsAttendanceRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/billing': {
      id: '/_workspace/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof WorkspaceSettingsBillingRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/company': {
      id: '/_workspace/settings/company'
      path: '/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof WorkspaceSettingsCompanyRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/credentials': {
      id: '/_workspace/settings/credentials'
      path: '/credentials'
      fullPath: '/settings/credentials'
      preLoaderRoute: typeof WorkspaceSettingsCredentialsRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/letterheads': {
      id: '/_workspace/settings/letterheads'
      path: '/letterheads'
      fullPath: '/settings/letterheads'
      preLoaderRoute: typeof WorkspaceSettingsLetterheadsRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/naming': {
      id: '/_workspace/settings/naming'
      path: '/naming'
      fullPath: '/settings/naming'
      preLoaderRoute: typeof WorkspaceSettingsNamingRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/team': {
      id: '/_workspace/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof WorkspaceSettingsTeamRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/_workspace/settings/usage': {
      id: '/_workspace/settings/usage'
      path: '/usage'
      fullPath: '/settings/usage'
      preLoaderRoute: typeof WorkspaceSettingsUsageRouteImport
      parentRoute: typeof WorkspaceSettingsRoute
    }
    '/kiosk/attendance/$id': {
      id: '/kiosk/attendance/$id'
      path: '/kiosk/attendance/$id'
      fullPath: '/kiosk/attendance/$id'
      preLoaderRoute: typeof KioskAttendanceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/assets/': {
      id: '/portal/assets/'
      path: '/assets'
      fullPath: '/portal/assets/'
      preLoaderRoute: typeof PortalAssetsIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/attendance/': {
      id: '/portal/attendance/'
      path: '/attendance'
      fullPath: '/portal/attendance/'
      preLoaderRoute: typeof PortalAttendanceIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/attendance/scan': {
      id: '/portal/attendance/scan'
      path: '/attendance/scan'
      fullPath: '/portal/attendance/scan'
      preLoaderRoute: typeof PortalAttendanceScanRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/sign/$token': {
      id: '/portal/sign/$token'
      path: '/sign/$token'
      fullPath: '/portal/sign/$token'
      preLoaderRoute: typeof PortalSignTokenRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_workspace/assets/issues/$id': {
      id: '/_workspace/assets/issues/$id'
      path: '/assets/issues/$id'
      fullPath: '/assets/issues/$id'
      preLoaderRoute: typeof WorkspaceAssetsIssuesIdRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/employees/$id/': {
      id: '/_workspace/employees/$id/'
      path: '/employees/$id'
      fullPath: '/employees/$id/'
      preLoaderRoute: typeof WorkspaceEmployeesIdIndexRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/employees/$id/edit': {
      id: '/_workspace/employees/$id/edit'
      path: '/employees/$id/edit'
      fullPath: '/employees/$id/edit'
      preLoaderRoute: typeof WorkspaceEmployeesIdEditRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/generate/bulk/$batchId': {
      id: '/_workspace/generate/bulk/$batchId'
      path: '/generate/bulk/$batchId'
      fullPath: '/generate/bulk/$batchId'
      preLoaderRoute: typeof WorkspaceGenerateBulkBatchIdRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/generate/custom/$id': {
      id: '/_workspace/generate/custom/$id'
      path: '/generate/custom/$id'
      fullPath: '/generate/custom/$id'
      preLoaderRoute: typeof WorkspaceGenerateCustomIdRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/generate/longform/$buildId': {
      id: '/_workspace/generate/longform/$buildId'
      path: '/generate/longform/$buildId'
      fullPath: '/generate/longform/$buildId'
      preLoaderRoute: typeof WorkspaceGenerateLongformBuildIdRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/generate/templates/$id': {
      id: '/_workspace/generate/templates/$id'
      path: '/generate/templates/$id'
      fullPath: '/generate/templates/$id'
      preLoaderRoute: typeof WorkspaceGenerateTemplatesIdRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_workspace/generate/templates/new': {
      id: '/_workspace/generate/templates/new'
      path: '/generate/templates/new'
      fullPath: '/generate/templates/new'
      preLoaderRoute: typeof WorkspaceGenerateTemplatesNewRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/portal/assets/issues/$id': {
      id: '/portal/assets/issues/$id'
      path: '/assets/issues/$id'
      fullPath: '/portal/assets/issues/$id'
      preLoaderRoute: typeof PortalAssetsIssuesIdRouteImport
      parentRoute: typeof PortalRoute
    }
  }
}

interface AuthRouteChildren {
  AuthCheckEmailRoute: typeof AuthCheckEmailRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthTwoFactorRoute: typeof AuthTwoFactorRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCheckEmailRoute: AuthCheckEmailRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthTwoFactorRoute: AuthTwoFactorRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface WorkspaceSettingsRouteChildren {
  WorkspaceSettingsAccountRoute: typeof WorkspaceSettingsAccountRoute
  WorkspaceSettingsAttendanceRoute: typeof WorkspaceSettingsAttendanceRoute
  WorkspaceSettingsBillingRoute: typeof WorkspaceSettingsBillingRoute
  WorkspaceSettingsCompanyRoute: typeof WorkspaceSettingsCompanyRoute
  WorkspaceSettingsCredentialsRoute: typeof WorkspaceSettingsCredentialsRoute
  WorkspaceSettingsLetterheadsRoute: typeof WorkspaceSettingsLetterheadsRoute
  WorkspaceSettingsNamingRoute: typeof WorkspaceSettingsNamingRoute
  WorkspaceSettingsTeamRoute: typeof WorkspaceSettingsTeamRoute
  WorkspaceSettingsUsageRoute: typeof WorkspaceSettingsUsageRoute
  WorkspaceSettingsIndexRoute: typeof WorkspaceSettingsIndexRoute
}

const WorkspaceSettingsRouteChildren: WorkspaceSettingsRouteChildren = {
  WorkspaceSettingsAccountRoute: WorkspaceSettingsAccountRoute,
  WorkspaceSettingsAttendanceRoute: WorkspaceSettingsAttendanceRoute,
  WorkspaceSettingsBillingRoute: WorkspaceSettingsBillingRoute,
  WorkspaceSettingsCompanyRoute: WorkspaceSettingsCompanyRoute,
  WorkspaceSettingsCredentialsRoute: WorkspaceSettingsCredentialsRoute,
  WorkspaceSettingsLetterheadsRoute: WorkspaceSettingsLetterheadsRoute,
  WorkspaceSettingsNamingRoute: WorkspaceSettingsNamingRoute,
  WorkspaceSettingsTeamRoute: WorkspaceSettingsTeamRoute,
  WorkspaceSettingsUsageRoute: WorkspaceSettingsUsageRoute,
  WorkspaceSettingsIndexRoute: WorkspaceSettingsIndexRoute,
}

const WorkspaceSettingsRouteWithChildren =
  WorkspaceSettingsRoute._addFileChildren(WorkspaceSettingsRouteChildren)

interface WorkspaceRouteChildren {
  WorkspaceAlertsRoute: typeof WorkspaceAlertsRoute
  WorkspaceAuditRoute: typeof WorkspaceAuditRoute
  WorkspaceBroadcastsRoute: typeof WorkspaceBroadcastsRoute
  WorkspaceCredentialsRoute: typeof WorkspaceCredentialsRoute
  WorkspaceDocumentsRoute: typeof WorkspaceDocumentsRoute
  WorkspaceLeaveRoute: typeof WorkspaceLeaveRoute
  WorkspaceOnboardingRoute: typeof WorkspaceOnboardingRoute
  WorkspaceRequestsRoute: typeof WorkspaceRequestsRoute
  WorkspaceSettingsRoute: typeof WorkspaceSettingsRouteWithChildren
  WorkspaceSupportRoute: typeof WorkspaceSupportRoute
  WorkspaceIndexRoute: typeof WorkspaceIndexRoute
  WorkspaceAssetsIdRoute: typeof WorkspaceAssetsIdRoute
  WorkspaceAttendanceIdRoute: typeof WorkspaceAttendanceIdRoute
  WorkspaceDocumentIdRoute: typeof WorkspaceDocumentIdRoute
  WorkspaceEmployeesNewRoute: typeof WorkspaceEmployeesNewRoute
  WorkspaceGenerateTypeRoute: typeof WorkspaceGenerateTypeRoute
  WorkspaceGenerateBlankRoute: typeof WorkspaceGenerateBlankRoute
  WorkspaceIncidentsIdRoute: typeof WorkspaceIncidentsIdRoute
  WorkspacePoliciesIdRoute: typeof WorkspacePoliciesIdRoute
  WorkspaceAssetsIndexRoute: typeof WorkspaceAssetsIndexRoute
  WorkspaceAttendanceIndexRoute: typeof WorkspaceAttendanceIndexRoute
  WorkspaceEmployeesIndexRoute: typeof WorkspaceEmployeesIndexRoute
  WorkspaceGenerateIndexRoute: typeof WorkspaceGenerateIndexRoute
  WorkspaceIncidentsIndexRoute: typeof WorkspaceIncidentsIndexRoute
  WorkspacePoliciesIndexRoute: typeof WorkspacePoliciesIndexRoute
  WorkspaceAssetsIssuesIdRoute: typeof WorkspaceAssetsIssuesIdRoute
  WorkspaceEmployeesIdEditRoute: typeof WorkspaceEmployeesIdEditRoute
  WorkspaceGenerateBulkBatchIdRoute: typeof WorkspaceGenerateBulkBatchIdRoute
  WorkspaceGenerateCustomIdRoute: typeof WorkspaceGenerateCustomIdRoute
  WorkspaceGenerateLongformBuildIdRoute: typeof WorkspaceGenerateLongformBuildIdRoute
  WorkspaceGenerateTemplatesIdRoute: typeof WorkspaceGenerateTemplatesIdRoute
  WorkspaceGenerateTemplatesNewRoute: typeof WorkspaceGenerateTemplatesNewRoute
  WorkspaceEmployeesIdIndexRoute: typeof WorkspaceEmployeesIdIndexRoute
}

const WorkspaceRouteChildren: WorkspaceRouteChildren = {
  WorkspaceAlertsRoute: WorkspaceAlertsRoute,
  WorkspaceAuditRoute: WorkspaceAuditRoute,
  WorkspaceBroadcastsRoute: WorkspaceBroadcastsRoute,
  WorkspaceCredentialsRoute: WorkspaceCredentialsRoute,
  WorkspaceDocumentsRoute: WorkspaceDocumentsRoute,
  WorkspaceLeaveRoute: WorkspaceLeaveRoute,
  WorkspaceOnboardingRoute: WorkspaceOnboardingRoute,
  WorkspaceRequestsRoute: WorkspaceRequestsRoute,
  WorkspaceSettingsRoute: WorkspaceSettingsRouteWithChildren,
  WorkspaceSupportRoute: WorkspaceSupportRoute,
  WorkspaceIndexRoute: WorkspaceIndexRoute,
  WorkspaceAssetsIdRoute: WorkspaceAssetsIdRoute,
  WorkspaceAttendanceIdRoute: WorkspaceAttendanceIdRoute,
  WorkspaceDocumentIdRoute: WorkspaceDocumentIdRoute,
  WorkspaceEmployeesNewRoute: WorkspaceEmployeesNewRoute,
  WorkspaceGenerateTypeRoute: WorkspaceGenerateTypeRoute,
  WorkspaceGenerateBlankRoute: WorkspaceGenerateBlankRoute,
  WorkspaceIncidentsIdRoute: WorkspaceIncidentsIdRoute,
  WorkspacePoliciesIdRoute: WorkspacePoliciesIdRoute,
  WorkspaceAssetsIndexRoute: WorkspaceAssetsIndexRoute,
  WorkspaceAttendanceIndexRoute: WorkspaceAttendanceIndexRoute,
  WorkspaceEmployeesIndexRoute: WorkspaceEmployeesIndexRoute,
  WorkspaceGenerateIndexRoute: WorkspaceGenerateIndexRoute,
  WorkspaceIncidentsIndexRoute: WorkspaceIncidentsIndexRoute,
  WorkspacePoliciesIndexRoute: WorkspacePoliciesIndexRoute,
  WorkspaceAssetsIssuesIdRoute: WorkspaceAssetsIssuesIdRoute,
  WorkspaceEmployeesIdEditRoute: WorkspaceEmployeesIdEditRoute,
  WorkspaceGenerateBulkBatchIdRoute: WorkspaceGenerateBulkBatchIdRoute,
  WorkspaceGenerateCustomIdRoute: WorkspaceGenerateCustomIdRoute,
  WorkspaceGenerateLongformBuildIdRoute: WorkspaceGenerateLongformBuildIdRoute,
  WorkspaceGenerateTemplatesIdRoute: WorkspaceGenerateTemplatesIdRoute,
  WorkspaceGenerateTemplatesNewRoute: WorkspaceGenerateTemplatesNewRoute,
  WorkspaceEmployeesIdIndexRoute: WorkspaceEmployeesIdIndexRoute,
}

const WorkspaceRouteWithChildren = WorkspaceRoute._addFileChildren(
  WorkspaceRouteChildren,
)

interface PortalRouteChildren {
  PortalAnnouncementsRoute: typeof PortalAnnouncementsRoute
  PortalCredentialsRoute: typeof PortalCredentialsRoute
  PortalDetailsRoute: typeof PortalDetailsRoute
  PortalDocumentsRoute: typeof PortalDocumentsRoute
  PortalLeaveRoute: typeof PortalLeaveRoute
  PortalOnboardingRoute: typeof PortalOnboardingRoute
  PortalPoliciesRoute: typeof PortalPoliciesRoute
  PortalRequestsRoute: typeof PortalRequestsRoute
  PortalIndexRoute: typeof PortalIndexRoute
  PortalAttendanceScanRoute: typeof PortalAttendanceScanRoute
  PortalSignTokenRoute: typeof PortalSignTokenRoute
  PortalAssetsIndexRoute: typeof PortalAssetsIndexRoute
  PortalAttendanceIndexRoute: typeof PortalAttendanceIndexRoute
  PortalAssetsIssuesIdRoute: typeof PortalAssetsIssuesIdRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalAnnouncementsRoute: PortalAnnouncementsRoute,
  PortalCredentialsRoute: PortalCredentialsRoute,
  PortalDetailsRoute: PortalDetailsRoute,
  PortalDocumentsRoute: PortalDocumentsRoute,
  PortalLeaveRoute: PortalLeaveRoute,
  PortalOnboardingRoute: PortalOnboardingRoute,
  PortalPoliciesRoute: PortalPoliciesRoute,
  PortalRequestsRoute: PortalRequestsRoute,
  PortalIndexRoute: PortalIndexRoute,
  PortalAttendanceScanRoute: PortalAttendanceScanRoute,
  PortalSignTokenRoute: PortalSignTokenRoute,
  PortalAssetsIndexRoute: PortalAssetsIndexRoute,
  PortalAttendanceIndexRoute: PortalAttendanceIndexRoute,
  PortalAssetsIssuesIdRoute: PortalAssetsIssuesIdRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  WorkspaceRoute: WorkspaceRouteWithChildren,
  PortalRoute: PortalRouteWithChildren,
  UnsubscribeRoute: UnsubscribeRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AcceptInvitationIdRoute: AcceptInvitationIdRoute,
  SignTokenRoute: SignTokenRoute,
  KioskAttendanceIdRoute: KioskAttendanceIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
